<template>
  <el-select v-model="info" value-key="id" clearable filterable :filter-method="getList" @change="changeInfo" placeholder="请输入名称">
      <el-option 
          class="optionsList"
          v-for="item in list"
          :key="item.id"
          :label="item.employeeName"
          :value="item">
          <div>
              <p>姓名:{{ item.employeeName }}</p>
              <p style="color: #666; font-size: 12px">手机号:{{ item.mobile }}</p>
          </div>
      </el-option>
  </el-select>
</template>

<script>
import { getEmployeeList } from "~/api/publicInfo";

export default {
  props: {
    value:{},
  },
  data() {
    return {
      list: [],
      info: {
        id:null,
      },
    };
  },
  watch: {
    value(newVal,oldVal){
      if(newVal){
        this.info.id = newVal
      }
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  methods: {
    changeInfo(val){
      this.$emit("change", val.id||null);
    },
    //查询客户
    getList(query,saleName) {
        let _this = this;
        //处理设置buyerid会导致查询的问题
        if (!query || this.id == query) {
            return false
        }
        let body = {
          employeeName:query,
          sellerId : sessionStorage.traderId,
          isDeleted: 0,
					isDisable: 0,
        };
        getEmployeeList(body).then(res=>{
          this.list = res.elements
        }).catch(err=>{

        })
    },
  },
}
</script>

<style>

</style>